// extracted by mini-css-extract-plugin
export default {"card":"llg5j___ContactCardCTA-module__card","prompt":"bpql7___ContactCardCTA-module__prompt"};